import { render, staticRenderFns } from "./HouseDetail.vue?vue&type=template&id=63538259"
import script from "./HouseDetail.vue?vue&type=script&lang=js"
export * from "./HouseDetail.vue?vue&type=script&lang=js"
import style0 from "./HouseDetail.vue?vue&type=style&index=0&id=63538259&prod&media=screen&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports